import { Box, Text, alpha, styled } from '@ltvco/refresh-lib/theme';

export const CardRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  height: '100%',
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px',
}));

export const ClaudeBadge = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '5px',
  marginBottom: theme.spacing(1),
  padding: '3px 9px',
  borderRadius: '100px',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.main,
  fontSize: 12,
  fontWeight: 700,
}));

export const CardTitle = styled(Text)({ fontSize: 16, fontWeight: 700 });

export const CardText = styled(Text)(({ theme }) => ({
  fontSize: 13,
  marginTop: theme.spacing(0.75),
}));
